import React, { useState, useContext } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  Image,
  Dimensions,
} from "react-native";
import { useColorScheme } from "react-native-appearance";
import { colors } from "../context/Colors";
// import MiniAudioPlayer from '../components/MiniAudioPlayer';
import Modal from "react-native-modal";
import Icon from "react-native-vector-icons/Ionicons";
import AppContext from "../context";
import { useDeviceOrientation } from "@react-native-community/hooks";
// import ImageZoom from "react-native-image-pan-zoom";

export default function GameDescription({ g, current }) {
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const orientation = useDeviceOrientation();
  const [modal, setModal] = useState(false);
  const { resolveURL, dict } = useContext(AppContext);
  const { width, height } = Dimensions.get("window");
  const [dimension, setDimension] = useState({ width, height });
  React.useEffect(() => {
    setDimension({ width, height });
  }, [orientation]);

  return (
    <>
      {g.imageReference && (
        <TouchableOpacity onPress={() => setModal(true)}>
          <Image
            source={{
              uri: resolveURL("game", g.imageReference, 600),
            }}
            style={{
              width: "100%",
              height: 0.56 * (dimension.width - 30),
              margin: "auto",
              marginBottom: 30,
              borderRadius: 10,
              maxWidth: 1000,
              maxHeight: 700,
            }}
            resizeMode={"contain"}
          />
          <Image
            source={require("../assets/enlarge-image.png")}
            style={{
              width: 26,
              height: 26,
              position: "absolute",
              right: 15,
              top: 15,
            }}
          />
        </TouchableOpacity>
      )}
      {g.description ? (
        <View
          style={{
            backgroundColor: colors[theme].gamePreamble,
            padding: 15,
            borderRadius: 10,
          }}
        >
          <Text style={{ color: colors[theme].text, opacity: 0.5 }}>
            {g.description}
          </Text>
        </View>
      ) : null}
      {g.challengeType !== "TakePhoto" && (
        <>
          <Text
            style={{
              fontSize: 18,
              fontWeight: "bold",
              color: colors[theme].text,
              marginTop: 30,
            }}
          >
            {dict.leadingQuestion[g.challengeType]
              ? dict.leadingQuestion[g.challengeType]
              : ""}
          </Text>
          <Text
            style={{
              marginTop: 10,
              fontSize: 16,
              color: colors[theme].text,
              opacity: 0.7,
            }}
          >
            {g.question}
          </Text>
        </>
      )}
      {/* {g.audioReference && (
        <MiniAudioPlayer audio={g.audioReference} current={current} />
      )} */}
      <Modal
        isVisible={modal}
        style={{ backgroundColor: "rgba(0,0,0,0.95)", margin: 0 }}
        hasBackdrop={false}
      >
        {/* <ImageZoom
          cropWidth={Dimensions.get("window").width}
          cropHeight={Dimensions.get("window").height}
          imageWidth={dimension.width}
          imageHeight={dimension.height}
        > */}
        {/* <ScrollView
          pinchGestureEnabled
          minimumZoomScale={1}
          maximumZoomScale={4}
          bouncesZoom={false}
        > */}
        <Image
          source={{
            uri: resolveURL("game", g.imageReference, 600),
          }}
          style={{
            width: dimension.width,
            height: dimension.height,
          }}
          resizeMode={"contain"}
        />
        {/* </ImageZoom> */}
        {/* </ScrollView> */}
        <TouchableOpacity
          style={{ position: "absolute", top: "5%", right: "5%" }}
          onPress={() => setModal(false)}
        >
          <Text
            style={{
              elevation: 5,
              textShadowColor: "#000",
              textShadowOffset: {
                width: 0,
                height: 2,
              },
              textShadowRadius: 3.85,
              shadowOpacity: 0.35,
            }}
          >
            <Icon name="close" color="#FFF" size={36} />
          </Text>
        </TouchableOpacity>
      </Modal>
    </>
  );
}
